<template>
  <div>
    <template v-if="modalInfo">
      <ModalInfo />
    </template>
    <template v-if="modalAuth">
      <ModalAuthUpdate @click-auth="openAuth()" @click-close-modal-auth="closeModalAuth()" />
    </template>
    <template v-if="loader">
      <Loader />
    </template>
    <DefaultLayout>
      <section class="color-data-table">
        <div class="container-table">
          <div class="new-invoice-info-table">
            <div class="new-invoice" @click="goNew()">
              <img :src="require('@/assets/icons/add.svg')" alt="New payment request" />
              <span>Payment Request</span>
            </div>
          </div>
        </div>
          <div>
            <template v-if="cTableIndex === 0">
              <TableInvoice
                :to="to"
                :total="total"
                :actual="list"
                :loaderTable="loaderTable"
                @collumnSelected="order = $event"
                @newIndex="indexTable = $event"
              />
            </template>
            <template v-if="cTableIndex === 1">
              <TableIncoming
                :to="incomingTotal"
                :total="incomingTotal"
                :actual="incomingList"
                :loaderTable="loaderTable"
                @collumnSelected="incomingOrder = $event"
                @newIndex="indexTable = $event"
                @sendMetaPay="sendMetaPay()"
              />
            </template>
            <template v-if="cTableIndex === 0">
              <template v-if="lastPage !== 1">
                <div class="container-pagination">
                  <!-- <template v-if="page !== 1"> -->
                  <select v-model="page" @change="goPage(page)">
                    <template v-for="(page, index) in lastPage">
                      <option :value="page" :key="index">{{page}}</option>
                    </template>
                  </select>
                  <!-- </template> -->
                  <!-- <div class="pagination">
                    <template v-if="page !== 1"> -->
                      <!-- <img
                        class="first"
                        :src="require('./../../src/assets/icons/leftArrow.svg')"
                        alt="last-page"
                        @click="goPage(1)"
                      />
                    </template>
                    <span v-for="previous in cPrevious" :key="previous" @click="goPage(previous)">
                      {{ previous }}
                    </span>
                    <span class="active">{{ page }} </span>
                    <span v-for="next in cNext" :key="next" @click="goPage(next)">
                      {{ next }}
                    </span>
                    <template v-if="page !== lastPage">
                      <img
                        class="last"
                        :src="require('./../../src/assets/icons/leftArrow.svg')"
                        alt="last-page"
                        @click="goPage(lastPage)"
                      /> -->
                    <!-- </template>
                  </div> -->
                </div>
              </template>
            </template>
            <template v-if="cTableIndex === 1">
              <template v-if="incomingLastPage !== 1">
                <div class="container-pagination">
                  <select v-model="incomingPage" @change="incomingGoPage(incomingPage)">
                    <template v-for="(page, index) in incomingLastPage">
                      <option :value="page" :key="index">{{page}}</option>
                    </template>
                  </select>
                  <!-- <div class="pagination">
                    <template v-if="incomingPage !== 1">
                      <img
                        class="first"
                        :src="require('./../../src/assets/icons/leftArrow.svg')"
                        alt="last-page"
                        @click="incomingGoPage(1)"
                      />
                    </template>
                    <span
                      v-for="previous in cIncomingPrevious"
                      :key="previous"
                      @click="incomingGoPage(previous)"
                    >
                      {{ previous }}
                    </span>
                    <span class="active">{{ incomingPage }} </span>
                    <span v-for="next in cIncomingNext" :key="next" @click="incomingGoPage(next)">
                      {{ next }}
                    </span>
                    <template v-if="incomingPage !== incomingLastPage">
                      <img
                        class="last"
                        :src="require('./../../src/assets/icons/leftArrow.svg')"
                        alt="last-page"
                        @click="incomingGoPage(incomingLastPage)"
                      />
                    </template>
                  </div> -->
                </div>
              </template>
            </template>
          </div>
        <template v-if="comment">
          <Comment />
        </template>
      </section>
    </DefaultLayout>
  </div>
</template>
<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import TableInvoice from '@/components/Tables/TableInvoice.vue';
import TableIncoming from '@/components/Tables/TableIncoming.vue';
import Loader from '@/components/Loader/Loader.vue';
import ModalInfo from '@/components/Modal/ModalInfo.vue';
import ModalAuthUpdate from '@/components/Modal/ModalAuthUpdate.vue';
import Comment from '@/components/Modal/ModalComment.vue';

export default {
  name: 'Home',
  data() {
    return {
      order: {
        collumn: 'created_at',
        orderBy: 'desc',
      },
      incomingOrder: {
        collumn: 'created_at',
        orderBy: 'desc',
      },
      indexTable: this.$store.getters.tableIndex || 0,
      first: true,
      loader: false,
      loaderTable: false,
      index: 0,
      list: '',
      token: null,
      to: 0,
      total: 0,
      page: 1,
      lastPage: 1,
      currentPage: 1,
      dataEcommerce: {},
      modalInfo: this.$store.getters.open,
      modalAuth: false,
      comment: this.$store.getters.openComment,
      incoming: this.$store.getters.incoming,
      incomingList: '',
      incomingTo: 0,
      incomingTotal: 0,
      incomingPage: 1,
      incomingLastPage: 1,
      icomingCurrentPage: 1,
    };
  },
  components: {
    DefaultLayout,
    TableInvoice,
    TableIncoming,
    Loader,
    ModalInfo,
    ModalAuthUpdate,
    Comment,
  },
  mounted() {
    this.getToken();
    this.setIndex();
    this.listInvoices();
    this.getAuthorizationTime();
  },
  watch: {
    order() {
      this.listInvoices();
    },
    incomingOrder() {
      this.allDataMagento();
    },
    '$store.getters.open': function modal() {
      this.modalInfo = this.$store.getters.open;
      this.incoming = this.$store.getters.incoming;
      if (!this.modalInfo && this.incoming) {
        this.allDataMagento();
      }
    },
    '$store.getters.openComment': function comment() {
      this.comment = this.$store.getters.openComment;
    },
    '$store.getters.deleteInvoiceConfirmed': function deleteInvoice() {
      if (this.$store.getters.deleteInvoiceConfirmed) {
        this.page = 1;
        this.listInvoices();
        this.$store.commit('UPDATE_CONFIRMED', false);
      }
    },
  },
  methods: {
    async authOpen() {
      window.open(`https://appcenter.intuit.com/connect/oauth2?client_id=${process.env.VUE_APP_CLIENT_ID}&response_type=code&scope=com.intuit.quickbooks.accounting&redirect_uri=${process.env.VUE_APP_URL}/oauth-redirect&state=1`, '_blank');
    },
    openAuth() {
      this.modalAuth = false;
      this.authOpen();
    },
    closeModalAuth() {
      this.modalAuth = false;
    },
    async getAuthorizationTime() {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.token}`,
        };
        const { data: response } = await this.$http.get('/v1/quickbooks/authorization', { headers });
        if (response.diff > 90) {
          this.modalAuth = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async isAuthorizationExpired() {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.token}`,
        };
        const { data: response } = await this.$http.get('/v1/quickbooks/authorization', { headers });
        return response.diff > 99;
      } catch (error) {
        console.error(error);
        return true;
      }
    },
    async sendMetaPay() {
      try {
        if (this.$store.getters.listInvoiceEcommerce.length === 0) {
          return;
        }
        const tokenExpired = await this.isAuthorizationExpired();
        if (tokenExpired) {
          this.modalAuth = true;
          return;
        }
        const body = {
          data: this.$store.getters.listInvoiceEcommerce,
        };
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        this.loader = true;
        const { data: response } = await this.$http.post('/v1/quickbooks/sync-ecommerce', body, { headers });
        this.message = response.data;
        if ((response.status === 'Authorization Token not found')
          || (response.status === 'Token is Invalid')
          || (response.status === 'Token is Expired')) {
          this.$store.commit('UPDATE_TABLE', 0);
          this.$router.push('/');
          this.loader = false;
        } else {
          this.loader = false;
          this.$store.commit('OPEN_MODAL');
          this.$store.commit('UPDATE_MESSAGE', this.message);
          this.$store.commit('INCOMING_UPDATE', true);
          this.$store.commit('CHANGE');
          // this.$store.dispatch('CLEAR');
          this.$store.commit('CLEAR_LIST', []);
        }
      } catch (error) {
        this.loader = false;
        console.error(error);
      }
    },
    goPage(page) {
      this.page = page;
      this.listInvoices();
    },
    incomingGoPage(incomingPage) {
      this.incomingPage = incomingPage;
      this.allDataMagento();
    },
    goNew() {
      this.$router.push('payment-request');
    },
    async getToken() {
      this.token = localStorage.getItem('token');
    },
    async setIndex() {
      localStorage.setItem('index', 0);
    },
    async listInvoices() {
      if (this.first) {
        this.loader = true;
        this.first = false;
      } else {
        this.loaderTable = true;
      }
      const requestOptions = {
        method: 'GET',
        headers: { Authorization: `Bearer ${this.token}` },
      };
      fetch(
        `${process.env.VUE_APP_API_URL}/v1/transactions/?page=${this.page}&orderby=${this.order.collumn}&ascordesc=${this.order.orderBy}`,
        requestOptions,
      ).then(async (response) => {
        const data = await response.json();
        this.list = data.transactions.data;
        this.total = data.transactions.total;
        this.to = data.transactions.to;
        this.currentPage = data.transactions.current_page;
        this.lastPage = data.transactions.last_page;

        // check for error response
        if (!response.ok) {
          // get error message from body or default to response status
          const error = (data && data.error) || response.status;
          this.loader = false;
          this.loaderTable = false;
          return Promise.reject(error);
        }
        this.loader = false;
        this.loaderTable = false;
        return false;
      })
        .catch((error) => {
          this.loader = false;
          this.loaderTable = false;
          this.errorMessage = error;
        });
    },
    // chamada para salvar dados do magento localmente
    async getEcommerce() {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.token}`,
        };
        this.loader = true;
        const { data: response } = await this.$http.get('/v1/quickbooks/magento', { headers });
        if (response.status === 200) {
          this.allDataMagento();
        }
        this.loader = false;
      } catch (error) {
        this.loader = false;
        console.error(error);
      }
    },
    // chamada para pegar os dados salvos localmente do magento
    async allDataMagento() {
      try {
        this.loader = true;
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.token}`,
        };
        const { data: response } = await this.$http.get(`/v1/quickbooks/magento-activies/?page=${this.incomingPage}&orderby=${this.incomingOrder.collumn}&ascordesc=${this.incomingOrder.orderBy}`, { headers });
        this.loader = false;
        this.incomingList = response.data.data;
        this.incomingTotal = response.data.total;
        this.incomingTo = response.data.to;
        this.incomingCurrentPage = response.data.current_page;
        this.incomingLastPage = response.data.last_page;
        // this.dataEcommerce = response.data;
        return response.data;
      } catch (error) {
        this.loader = false;
        console.error(error);
      }
      return '';
    },
  },
  computed: {
    cTableIndex() {
      if (this.$store.getters.tableIndex === 1) {
        this.getEcommerce();
      }
      if (this.$store.getters.tableIndex === 0) {
        this.listInvoices();
      }
      return this.$store.getters.tableIndex;
    },
    actual() {
      if (this.list) {
        return this.list[this.index];
      }
      return '';
    },
    cNext() {
      let i = this.page;
      const max = i + 10;
      const arrPrevious = [];
      while (i < max) {
        i += 1;
        if (i <= this.lastPage) {
          arrPrevious.push(i);
        }
      }
      return arrPrevious;
    },
    cPrevious() {
      let i = this.page;
      const max = i + 10;
      const arrPrevious = [];
      while (i < max && i !== 0) {
        i -= 1;
        if (i < this.page && i !== 0) {
          arrPrevious.push(i);
        }
      }
      return arrPrevious.reverse();
    },
    cIncomingNext() {
      let i = this.incomingPage;
      const max = i + 10;
      const arrPrevious = [];
      while (i < max) {
        i += 1;
        if (i <= this.incomingLastPage) {
          arrPrevious.push(i);
        }
      }
      return arrPrevious;
    },
    cIncomingPrevious() {
      let i = this.incomingPage;
      const max = i + 10;
      const arrPrevious = [];
      while (i < max && i !== 0) {
        i -= 1;
        if (i < this.incomingPage && i !== 0) {
          arrPrevious.push(i);
        }
      }
      return arrPrevious.reverse();
    },
  },
};
</script>
<style lang="scss" scoped>
.container-pagination {
  margin-top: 22px;
  display: inline-block;
  select {
    cursor: pointer;
    outline: none;
    border: 1px solid $dataTable;
    padding: 2px 25px 2px 10px;
    border-radius: 4px;
    background-image: url("../../src/assets/icons/v.svg");
    background-position: center right;
  }
  .pagination {
    margin: 0 auto;
    display: flex;
    align-items: center;
    .first {
      padding: 4px;
      width: 22px;
      height: 22px;
      background-color: #dceeff;
      border-radius: 2.2px;
      margin-right: 22px;
      cursor: pointer;
    }
    .last {
      padding: 4px;
      width: 22px;
      height: 22px;
      background-color: #dceeff;
      transform: rotate(180deg);
      border-radius: 2.2px;
      margin-left: 22px;
      cursor: pointer;
    }
    span {
      cursor: pointer;
      margin-left: 4px;
      margin-right: 4px;
      text-decoration: underline;
      font-size: 14px;
      color: $header;
    }
    .active {
      height: 22px;
      width: 22px;
      background-color: $header;
      border-radius: 11px;
      color: $white;
      cursor: default;
    }
  }
}

.color-data-table {
  padding-top: 10px !important;
  .container-table {
    margin-bottom: -25px !important;
    width: 92.6vw;
    margin: 0 auto;
    @media (max-width: 960px) {
      margin-bottom: 0 !important;
    }
    h4 {
      font-weight: 500;
      font-size: 14px;
      text-align: right;
      margin-bottom: 5px;
      color: #162056;
      @media (max-width: 600px) {
        width: 100%;
        padding-right: 10px;
        margin-right: -10px;
      }
    }
    .new-invoice-info-table {
      @media (max-width: 960px) {
        padding-left: 0 !important;
      }
      .new-invoice {
        cursor: pointer;
        padding: 22px;
        margin-top: 5px;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        width: 280px;
        height: 41px;
        border: solid 2px $header;
        border-radius: 40px;
        @media (max-width: 960px) {
          margin-bottom: 5px;
          width: 80%;
          min-width: 250px;
          justify-content: center;
        }
        img {
          margin-right: 16.7px;
        }
        span {
          white-space: nowrap;
          font-weight: 600;
          font-size: 20px;
          color: $header;
        }
      }
    }
  }
  min-height: calc(100vh - 83px);
  padding-top: 33px;
  background-color: $backgroundData;
  padding: 2rem;
  @media (max-width: 960px) {
    padding: 0.3rem;
  }
}

</style>
